module.exports = __webpack_public_path__ + "img/3.48724ae3.jpg";